import * as React from 'react'
import ReactMarkdown from 'react-markdown'

import { ISectionContent } from '../../util/profileContent'
import { Container } from './RichTextView.styles'

interface IProps {
  content: ISectionContent
}

export default function RichTextView(props: IProps) {
  const {
    content: { markdown },
  } = props

  return (
    <Container>
      <ReactMarkdown>{markdown}</ReactMarkdown>
    </Container>
  )
}
